import { Link as RouterLink } from 'react-router-dom';

import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 100%;
  width: auto;
  border-radius: 5px;
`;

export const TableContainer = styled.div`
  background-color: white;
  width: 100%;
  padding: 20px;
  font-size: 30px;
  border-radius: 5px;
  overflow: auto;
`;

export const DashBoardTitle = styled.div`
  font-size: 30px;
  font-weight: 600;
  width: 100%;
  text-align: left;
  padding: 20px 20px 0 30px;
  color: darkgray;
`;

export const StatusBtn = styled.button<{ status: string | null }>`
  display: inline-block;
  padding: 4px 15px;
  border-radius: 15px;
  color: white;
  text-align: center;

  background-color: ${({ status }) => {
    switch (status) {
      case null: // '미확인' 상태
        return '#C0C4CC';
      case 'c': // '확인중' 상태
        return '#F56C6C';
      case 'f': // '처리완료' 상태
        return '#40a0fb';
      default: // 그 외의 상태
        return '#C0C4CC';
    }
  }};
`;

export const StyledLink = styled(RouterLink)<{ current: boolean }>`
  color: ${props => (props.current ? 'black' : 'darkgray')};
  text-decoration: none;

  &:hover {
    color: ${props => (!props.current ? '#40a0fb' : '#40a0fb')};
  }

  &:not(:last-child)::after {
    content: ' > ';
    margin: 0 10px;
  }
`;

export const LinkNavigate = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 20px 0 30px;
`;

export const NoDataText = styled.div`
  font-size: 16px;
  padding: 10px;
  color: #ddd;
`;
